var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 16.668V15.418M4.16602 16.668V15.418",
    stroke: "black",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 12.5C1.66602 11.7234 1.66602 11.3352 1.79288 11.0288C1.96204 10.6205 2.2865 10.296 2.69487 10.1268C3.00117 10 3.38945 10 4.16602 10H15.8327C16.6093 10 16.9975 10 17.3038 10.1268C17.7122 10.296 18.0367 10.6205 18.2058 11.0288C18.3327 11.3352 18.3327 11.7234 18.3327 12.5C18.3327 13.2766 18.3327 13.6648 18.2058 13.9712C18.0367 14.3795 17.7122 14.704 17.3038 14.8732C16.9975 15 16.6093 15 15.8327 15H4.16602C3.38945 15 3.00117 15 2.69487 14.8732C2.2865 14.704 1.96204 14.3795 1.79288 13.9712C1.66602 13.6648 1.66602 13.2766 1.66602 12.5Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.9987C17.5 6.856 17.5 5.28466 16.5237 4.30834C15.5474 3.33203 13.976 3.33203 10.8333 3.33203H9.16667C6.02397 3.33203 4.45262 3.33203 3.47631 4.30834C2.5 5.28466 2.5 6.856 2.5 9.9987",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4173 10.0013V8.7513C15.4173 7.17995 15.4173 6.39428 14.9292 5.90613C14.441 5.41797 13.6553 5.41797 12.084 5.41797H7.91732C6.34597 5.41797 5.56029 5.41797 5.07214 5.90613C4.58398 6.39428 4.58398 7.17995 4.58398 8.7513V10.0013",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.83203V9.9987",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/Bed.d2507a20659ec6dbb6c508e95ffce64b.svg";
export { ForwardRef as ReactComponent };